import React, { useEffect, useState } from 'react'
import Team from '@assets/team.svg'
import useAuctionManager from '@hooks/useAuctionManager'
import InfoIcon from '@assets/info.svg'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@components/Tooltip'
import { isPast } from 'date-fns'

const TeamDay = () => {
  const { currentListing } = useAuctionManager()

  const [auctionEnded, setAuctionEnded] = useState(undefined)

  useEffect(() => {
    if (!currentListing) return

    const auctionEndDate = new Date(currentListing?.endAt.toNumber() * 1000)
    // check if highest bidder date was at least 1 min ago and auction has ended
    setAuctionEnded(isPast(auctionEndDate))
  }, [currentListing])

  if (auctionEnded === undefined) return null

  return (
    <div
      className={`flex border-dark-6 ${auctionEnded ? 'border-t-0' : auctionEnded === false ? 'border-t-[1px]' : ''}`}
    >
      <div className="flex p-4 gap-2 text-sm font-semibold w-full">
        <Team color={'white'} />
        <span>Team Day</span>
        <div className="flex flex-1 items-end justify-end">
          <div className="flex items-center justify-center rounded-full hover:bg-dark-5 cursor-pointer p-[0.5px]">
            <TooltipProvider delayDuration={0}>
              <Tooltip>
                <TooltipTrigger>
                  <InfoIcon color="var(--dewi_colors_dark_3)" />
                </TooltipTrigger>
                <TooltipContent className="max-w-[300px] mr-12 p-4">
                  <p className="text-xs text-white font-semibold">
                    Every 5th day, all the proceeds from the auction will be
                    distributed to the team to help support the development of
                    DewiCats.
                  </p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeamDay
